export default __webpack_public_path__ + "static/worker-1c0270a2fb710ca261d688251941c2e6.jpg";